// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Import.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { Tabs, Tab } from 'share/components/controls/Izenda.Tab';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import ReportTab from './Report/Izenda.ReportTab';
import DashboardTab from './Dashboard/Izenda.DashboardTab';
import ImportBar from './ActionBar/Izenda.ImportBar';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.ImportActions';
import ImportFile from './Izenda.ImportFile';
import { observable } from 'mobx';
import DatabaseMappingList from './DatabaseMapping/Izenda.DatabaseMappingList';
import Dimensions from 'share/components/hoc/Izenda.Dimensions';

@connect(actions, Dimensions)
export default class Import extends Component {
  constructor(props: any) {
    super(props);
    this.uiStore = observable({
      defaultHeight: 0
    });
  }

  setDom = (dom: any): void => {
    this.domNode = dom;
  };

  componentDidMount() {
    if (this.uiStore.defaultHeight != this.domNode.clientHeight) {
      this.uiStore.defaultHeight = this.domNode.clientHeight;
    }
  }

  renderImportTabs() {
    const {
      store,
      store: { model, hasErrorReportTab, hasErrorDashboardTab },
      store: { model: { activeTabKey } }
    } = this.props;
    const height = this.props.height > 0 ? this.props.height : this.uiStore.defaultHeight;
    const reportTabTitle = (
      <div>
        <span>{store.reportTabTitle}</span>
        {hasErrorReportTab && <span className="icon-attention warning-color" />}
      </div>
    );
    const dashboardTabTitle = (
      <div>
        <span>{store.dashboardTabTitle}</span>
        {hasErrorDashboardTab && <span className="icon-attention warning-color" />}
      </div>
    );

    return (
      <div className="izenda-Wrapper-content">
        <ScrollBox>
          <div className="u_fullHeight u_paddingLeftRight">
            <Tabs
              activeTabKey={activeTabKey}
              panelClassName="u_noMarginAll"
              onChange={model.changeActiveTabKey.bind(model)}
              canChangeTab={this.props.canChangeTab}
            >
              <Tab title={reportTabTitle} tabKey="report">
                <ReportTab height={height} store={store} />
              </Tab>
              <Tab title={dashboardTabTitle} tabKey="dashboard">
                <DashboardTab height={height} store={store} />
              </Tab>
            </Tabs>
            <DatabaseMappingList store={store} />
          </div>
        </ScrollBox>
      </div>
    );
  }

  render() {
    const { store, store: { hasFileLoaded } } = this.props;

    return (
      <div className="izenda-Import izenda-TableLayout" ref={this.setDom}>
        <div className="izenda-TableLayout-Cell">
          {hasFileLoaded ? (
            <section className="izenda-Wrapper">
              <ImportBar store={store} />
              {this.renderImportTabs()}
            </section>
          ) : (
            <ImportFile store={store} />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Izenda.Import.js